import { render } from "./ConfirmPopup.vue?vue&type=template&id=c2774c1c&ts=true"
import script from "./ConfirmPopup.vue?vue&type=script&lang=ts"
export * from "./ConfirmPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__